import React from 'react'
import { Box, Typography, Alert, Paper, Chip } from '@mui/material'
import ConfirmDialog from '../../../shared/dialogs/ConfirmDialog'
import { poolwerxColors } from '../../../../theme/colors'

interface ActiveFilter {
  label: string
  value: string
}

interface ExportConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  activeFilters: ActiveFilter[]
  recordCount: number
  exporting?: boolean
}

const ExportConfirmDialog: React.FC<ExportConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  activeFilters,
  recordCount,
  exporting = false
}) => {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      tone="neutral"
      variant="confirmation"
      title="Export Filtered Data"
      pending={exporting}
      confirmLabel="Export Excel"
      body={
        <Box>
          <Alert severity="info" sx={{ mb: 3 }}>
            <Typography variant="body2">
              The export will only include franchise partners matching the current filters.
            </Typography>
          </Alert>

          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
              Active Filters
            </Typography>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                bgcolor: 'grey.50',
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 2
              }}
            >
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {activeFilters.map((filter, index) => (
                  <Chip
                    key={index}
                    label={`${filter.label}: ${filter.value}`}
                    size="small"
                    sx={{
                      bgcolor: poolwerxColors.tealLight,
                      color: poolwerxColors.teal,
                      fontWeight: 500,
                      '& .MuiChip-label': {
                        px: 1.5
                      }
                    }}
                  />
                ))}
              </Box>
            </Paper>
          </Box>

          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ color: poolwerxColors.teal }}>
              {recordCount} Franchise Partner{recordCount !== 1 ? 's' : ''} will be exported
            </Typography>
          </Box>
        </Box>
      }
    />
  )
}

export default ExportConfirmDialog
